/* global jsPAL, confEvent */

var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.esm = leica.pi.esm || {};

/**
 * eSlideManager conferencing specific logic
 * @param {DOM Document} document
 * @param {jQuery} $
 * @returns {leica.pi.esm.cConferencing.self}
 */
leica.pi.esm.cConferencing = function (document, $)
{
    var self = {};

    self.vilDiv = null;
    /**
     * The div id of the accordian
     */
    self.accordionDivId = null;
    /**
     * dbo.Case.Id
     */
    self.caseId = null;
    /**
     * Dbo.Image.ImageId
     */
    self.imageId = null;
    /**
     * Popup window title
     */
    self.popupTitle = "Case Conference";

    /**
     * Image attributes passed in opening conference message, JSON format
     */
    self.imageAttributes = null;

    /**
     * Extract image attributes from conference message
     * @param {type} dscRoot
     * @param {type} imageAttrJsonFunc
     * @returns {unresolved}
     */
    self.extractImageAttributesFromConferenceMessage = function (dscRoot, imageAttrJsonFunc) {
        var image = $(dscRoot).find('Image').toArray();
        return imageAttrJsonFunc(image[image.length - 1]);
    };

    /**
     * Encapsulate the logic for converting ImageServer imageId (with '@' prefix) to entity id
     * @param {string} uScopeImageId
     * @returns {unresolved}
     */
    self.uScopeImageIdToEntityImageId = function (uScopeImageId) {
        return uScopeImageId.substring(1); // strip off "@"
    };

    /**
     * Initialze the conference with the case id
     * Conference followers will call into this method
     * Bind uscope image change event
     * @param caseId The study id
     */
    self.initConference = function (caseId)
    {
        self.caseId = caseId;     

        self.bindUscopeImageChangeEvent();
        self.bindConferenceLeaderChangedEvent();

        //only followers call initConference
        self.becameFollower();
    };

    /**
     * Creates the dscPopup modal window
     * @param dscRoot The conferencing xml root
     * @param buildConfImageAttributeJson Function to create conferening image json
     * @param caseId Case id
     * @param dscId Core.Dsc.Id
     * @param dscUserId Core.DscUser.UserId
     * @param dscLoginUserId Logged in User Id
     * @param dscFullName Conferencing username
     * @param dscAuthToken Auth Token from the logged in user
     * @param endPointURL URL of end point to retrieve a pop-up viewer, given a set of VIL specific query parameters
     */
    self.createEsmPopUpConference = function (dscRoot, buildConfImageAttributeJson, caseId, dscId, dscUserId, dscLoginUserId, dscFullName, dscAuthToken, endPointURL)
    {
        self.imageAttributes = self.extractImageAttributesFromConferenceMessage(dscRoot, buildConfImageAttributeJson);
        self.currentImageId = self.imageAttributes.imageId;

        // TODO: Find out why some settings added here (like accordionSettings : {displayHandlerTitle: false}
        // do not show up in returned response
        var viewerSettings = {
            "CaseId": caseId,
            "PopupTitle": self.popupTitle,
            "DisplayMode": "popup",
            "DisplayDST": true,
            "DstSummary": true,
            "DstTitle": "Case",
            "NextPreviousButton": true,
            "DstEnhancedView": leica.pi.util.conference.dstEnhancedView(), // todo: just remove this line, and the setting will be populated on server side
            "DstLockMode": true,
            "DscId": dscId,
            "DscUserId": dscUserId,
            "DscLoginUserId": dscLoginUserId,
            "DscFullName": dscFullName,
            "DscAuthToken": dscAuthToken,
            "DstDisplayMultiSlide": false
        };

        //create the settings object using the vilsettings endpoint and the viewer settings           
        $.getJSON(endPointURL, viewerSettings).done(function (response) {
            {
                // fetch the vil settings object
                var vilSettings = response;
                
                // The following line causes a problem: when leader changes slides, uScope opens another view pane (multi-image mode) -cb  
                vilSettings.dstSettings.autoSelectSlide = false; // tell dst not to select a slide by default when initialized
                if (isPALMode())
                {
                    $('div.vilDiv:visible').each(function () {
                        jsPAL.saveVil($(this));
                    });
                }

                $("div.vilDiv").remove();

                //create the vil settings object 
                self.vilDiv = $("<div>", {"id": "dscPopup", "style": "display:none;", "class": "vilDiv"}).css('overflow', 'hidden').appendTo("body");

                $.when(self.vilDiv.vil(vilSettings)).done(function () {
                    // Note: $(document) != $() in this context -cb
                    $(document)
                            .trigger(confEvent.join, {src: 'Vil', lead: false, userName: dscFullName}) //tell uscope and the slide tray to join 
                            .trigger(confEvent.openimage, self.imageAttributes); // can't trigger this event until after join conference; will select the conferenced image/slide in the DST
                    
                    self.vilDiv.show(); //show the vil div
                    self.vilDiv.uScopeResize();   // cause uScope resize so as to reposition toolbar properly (TODO: Use just CSS for this)  
                    self.accordionDivId = self.vilDiv.vil().getConfiguration().accordionSettings.divId;
                    $(".dst_accordion", self.vilDiv).accordion("refresh"); // this may be necessary to properly sice the dst accordion if prior cases enabled
                    //initialize the conference with a case
                    self.initConference(caseId);
                });

            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            alert("Error getting VilSettings" + errorThrown);
        });
    };


    /**
     * Refresh the DST accordion container [repaint]
     */
    self.refreshAccordian = function ()
    {     
       	var mainAccordion = $('#' + self.accordionDivId, self.vilDiv);
        if (mainAccordion.length > 0 &&  mainAccordion.is(':ui-accordion'))
        {
            mainAccordion.accordion("destroy").accordion();
        }    
    };

    /**
     * Removes any added accordion elements
     * and also unbinds the knockout viewmodels
     */
    self.removePreviousConferencingElements = function ()
    {
        self.refreshAccordian();

        //remove any previous bindings
        // ESM does not have any live bound items

        //remove the content divs from the accordion
        $('div.' + self.confernceClass, self.vilDiv).remove();
        $('h3.' + self.confernceClass, self.vilDiv).remove();
    };

    /**
     * Bind to the image change event generated by VIL
     * The event is fired whenever the image that is being viewed by the leader changes
     */
    self.bindUscopeImageChangeEvent = function ()
    {
        $(document).on('us_evIMAGEREADY.VIL', function (e, parms)
        {
            //update the currently being viewed image id
            self.imageId = parms.imageId.replace("@", "");

            //the image has changed so update anything that changes with it
            self.removePreviousConferencingElements();
            
            //resize the window whenever a new image arrives
            //prevents the toolbar from showing wonky
            $(window).trigger('resize');
        });
    };

    /**
     * You became the conference leader     
     */
    self.becameLeader = function ()
    {
        //alert('you are the leader');

        $.getDstInstance().enableSlideSelection();
        $.getDstInstance().showNextPreviousButtons();
        $.getDstInstance().enableEnhancedView();
    };

    /**
     * You became a conference follower
     */
    self.becameFollower = function ()
    {
        //alert('you are the follower');

        $.getDstInstance().disableSlideSelection();
        $.getDstInstance().hideNextPreviousButtons();
        $.getDstInstance().disableEnhancedView();
    };

    /**
     * Bind to the conference leadership change event.
     */
    self.bindConferenceLeaderChangedEvent = function ()
    {
        $(document).on(confEvent.leadChange + ".dsc", function (e, json)
        {
            if (json === undefined)
            {
                return;
            }
            var newLeaderState = (true === json.lead) ? true : false;
            if (newLeaderState)
            {
                self.becameLeader();
            }
            else
            {
                self.becameFollower();
            }
        });
    };

    return self;

};
// NetBeans navigator does not understand IIFEs. This is a workaround.
leica.pi.esm.conferencing = new leica.pi.esm.cConferencing(document, window.jQuery);